import { DateUtils } from '@vectord/utils';

function isOngoingClass(classStartTime) {
  const minDifference = DateUtils.getMinutesDifference(
    classStartTime,
    new Date()
  );

  return minDifference >= -180 && minDifference < 0;
}

export default isOngoingClass;
